module.exports = __webpack_public_path__ + "static/media/1.7ba2ccf1.png";